// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_lCBW5 {
  width: 100%;
  max-width: 370px;
  background-color: var(--white-color);
  padding: 0rem;
  border-radius: 0.375rem;
}

.inputGroup_Gygo8 {
  margin-bottom: 0px;
}

.input_PQ9ba {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.375rem;
  background-color: var(--f4-background);
  border: 0px;
}

.labelContainer_pkIz6 {
  margin-top: 16px;
}

.label_gjle_ {
  font-size: 0.875rem;
  font-weight: 500;
  color: #292a2b;
}

.conditionsContainer_gdmKn {
  display: flex;
  padding: 5px 9px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--f4-background);
  .conditions_dQgom {
    display: flex;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
    .condition_YYg1u {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      border: 1px solid #e0e3e6;
      background: var(--white-background);
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
      color: #2a2e32;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      overflow: hidden;
      textarea,
      input,
      span {
        font-family: "Inter", sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        overflow: hidden;
        border: none;
        padding: 0;
      }
    }
    .conditionInput_r0X9Q {
      outline: none;
      border: none;
      resize: none;
      field-sizing: content;
    }
  }
  input {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px; 
    box-sizing: border-box;
    &::placeholder {
      color: var(--_71717a-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px; 
    }
  }
}


.icon_pszAs {
  margin-left: 0.25rem;
  color: var(--dc2626-color);
}

.textarea_GVOB3 {
  width: 100%;
  max-width: 330px;
  padding: 0.5rem;
  border: 0px solid #e5e7eb;
  border-radius: 0.375rem;
  resize: none;
  background-color: #f4f4f400;
  outline: none;
  height: 50px;
  margin: 0px;
}

.actionButtons_RC799 {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}



.infoContainerWrapper_Q4HSg {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
}
.infoContainer_jRp07 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_n35SY {
  &.active_uFEO3 {
    display: block;
  }
  &.disabled_KYyys {
    display: none;
  }
}


.contentInput_0l7_R {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_MVGDl {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .optionsContentInput_F0bQ3 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.labelName_c3V6e input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: #000000;
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: #000000;
  }
}

.labelName_c3V6e input:not([disabled]) {
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.filtersLabelOptions_uogkr {
  border-left: 1px solid #c3c3c3;
  display: flex;
  padding-left: 22px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  p {
    margin: 5px;
  }
}

.changeTypeContainerButton_cHfgn {
  display: flex;
  width: 100%;
  display: flex;
  height: 50px;
  padding: 6px 5px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--f9-background);
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    background-color: transparent;
    outline: none;
    border: 1px solid transparent;
    color: var(--_b4-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
  }
  .typeFilterBtn_vU6Vc {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    border: 1px solid var(--_0000001a-shadow);
    background: var(--white-background);
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    color: #0d0d0d;
  }
}

.buttonAddFilter_MdgJ8 {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  background: var(--white-background);
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/TelamatelFormAutomate/selectInfoToProcces/RulesFilterAvanced/RulesFilterAvanced.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,eAAe;IACf;MACE,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,yBAAyB;MACzB,mCAAmC;MACnC,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB;;;QAGE,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,UAAU;MACZ;IACF;IACA;MACE,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,qBAAqB;IACvB;EACF;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;;AAGA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;;AAGA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB;;;sCAGkC;IAClC,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;IACnC;;;sCAGkC;IAClC,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".container {\n  width: 100%;\n  max-width: 370px;\n  background-color: var(--white-color);\n  padding: 0rem;\n  border-radius: 0.375rem;\n}\n\n.inputGroup {\n  margin-bottom: 0px;\n}\n\n.input {\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  background-color: var(--f4-background);\n  border: 0px;\n}\n\n.labelContainer {\n  margin-top: 16px;\n}\n\n.label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #292a2b;\n}\n\n.conditionsContainer {\n  display: flex;\n  padding: 5px 9px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 5px;\n  background: var(--f4-background);\n  .conditions {\n    display: flex;\n    width: 100%;\n    gap: 10px;\n    flex-wrap: wrap;\n    .condition {\n      display: flex;\n      padding: 6px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 30px;\n      border: 1px solid #e0e3e6;\n      background: var(--white-background);\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n      color: #2a2e32;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;\n      overflow: hidden;\n      textarea,\n      input,\n      span {\n        font-family: \"Inter\", sans-serif;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        overflow: hidden;\n        border: none;\n        padding: 0;\n      }\n    }\n    .conditionInput {\n      outline: none;\n      border: none;\n      resize: none;\n      field-sizing: content;\n    }\n  }\n  input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px; \n    box-sizing: border-box;\n    &::placeholder {\n      color: var(--_71717a-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px; \n    }\n  }\n}\n\n\n.icon {\n  margin-left: 0.25rem;\n  color: var(--dc2626-color);\n}\n\n.textarea {\n  width: 100%;\n  max-width: 330px;\n  padding: 0.5rem;\n  border: 0px solid #e5e7eb;\n  border-radius: 0.375rem;\n  resize: none;\n  background-color: #f4f4f400;\n  outline: none;\n  height: 50px;\n  margin: 0px;\n}\n\n.actionButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n\n\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n\n.contentInput {\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.labelName input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #000000;\n  }\n}\n\n.labelName input:not([disabled]) {\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.filtersLabelOptions {\n  border-left: 1px solid #c3c3c3;\n  display: flex;\n  padding-left: 22px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  p {\n    margin: 5px;\n  }\n}\n\n.changeTypeContainerButton {\n  display: flex;\n  width: 100%;\n  display: flex;\n  height: 50px;\n  padding: 6px 5px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 12px;\n  background: var(--f9-background);\n  > button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    background-color: transparent;\n    outline: none;\n    border: 1px solid transparent;\n    color: var(--_b4-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; \n  }\n  .typeFilterBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    border: 1px solid var(--_0000001a-shadow);\n    background: var(--white-background);\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    color: #0d0d0d;\n  }\n}\n\n.buttonAddFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  background: var(--white-background);\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_lCBW5`,
	"inputGroup": `inputGroup_Gygo8`,
	"input": `input_PQ9ba`,
	"labelContainer": `labelContainer_pkIz6`,
	"label": `label_gjle_`,
	"conditionsContainer": `conditionsContainer_gdmKn`,
	"conditions": `conditions_dQgom`,
	"condition": `condition_YYg1u`,
	"conditionInput": `conditionInput_r0X9Q`,
	"icon": `icon_pszAs`,
	"textarea": `textarea_GVOB3`,
	"actionButtons": `actionButtons_RC799`,
	"infoContainerWrapper": `infoContainerWrapper_Q4HSg`,
	"infoContainer": `infoContainer_jRp07`,
	"contentContainer": `contentContainer_n35SY`,
	"active": `active_uFEO3`,
	"disabled": `disabled_KYyys`,
	"contentInput": `contentInput_0l7_R`,
	"titleContentInput": `titleContentInput_MVGDl`,
	"optionsContentInput": `optionsContentInput_F0bQ3`,
	"labelName": `labelName_c3V6e`,
	"filtersLabelOptions": `filtersLabelOptions_uogkr`,
	"changeTypeContainerButton": `changeTypeContainerButton_cHfgn`,
	"typeFilterBtn": `typeFilterBtn_vU6Vc`,
	"buttonAddFilter": `buttonAddFilter_MdgJ8`
};
export default ___CSS_LOADER_EXPORT___;
